var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"add-provider-header"},[_c('h1',{staticClass:"add-provider-title"},[_vm._v("Novo Fornecedor")]),_c('span',{staticClass:"material-icons add-provider-cancel-icon",on:{"click":_vm.cancel}},[_vm._v("cancel")])])
}
var staticRenderFns = []

export { render, staticRenderFns }